import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./BusinessDetails.module.css";

/** Strips the display spacing from a phone number so it can be dialled from a `tel:` link. */
const toTelHref = (phone: string): string => `tel:${phone.replace(/\s/g, "")}`;

export type BusinessDetailsProps = {
	/** Extra class from the host, so a dark footer and a light card can each set the colours. */
	className?: string;
};

/**
 * The operating company's name, registered address, email and phone (TTWEB-7). Shown where users and
 * payment-gateway reviewers look for them: the landing footer and Help & Support. Read from
 * `common:company`, the same source as the Contact page and the legal pages, so the details are
 * written once and can never disagree. Colours inherit, so the host decides how it looks.
 */
export const BusinessDetails = ({ className }: BusinessDetailsProps) => {
	const { t } = useTranslation("common");
	const email = t("company.email");
	const phone = t("company.phone");

	return (
		<address className={className ? `${styles.details} ${className}` : styles.details}>
			<span className={styles.name}>{t("company.name")}</span>
			<span>{t("company.address")}</span>
			<span>
				{t("businessDetails.email")} <a href={`mailto:${email}`}>{email}</a>
			</span>
			<span>
				{t("businessDetails.phone")} <a href={toTelHref(phone)}>{phone}</a>
			</span>
		</address>
	);
};

export default BusinessDetails;
